import { forwardRef } from "react";

interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = "", error, ...props }, ref) => {
    return (
      <div className="relative">
        <textarea
          ref={ref}
          className={`w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:outline-none focus:border-primary dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:focus:border-primary ${
            error ? "border-red-500" : "border-gray-300"
          } ${className}`}
          {...props}
        />
        {error && (
          <p className="mt-1 text-sm text-red-500 dark:text-red-400">{error}</p>
        )}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";
